import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=c3ca54be&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ca54be')) {
      api.createRecord('c3ca54be', component.options)
    } else {
      api.reload('c3ca54be', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=c3ca54be&", function () {
      api.rerender('c3ca54be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYR2oHuJ35SY/JS/comp/IncreaseNumber.vue"
export default component.exports